import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isAllergenPresent',
  standalone: true,
  pure: true
})
export class IsAllergenPresentPipe implements PipeTransform {
  transform(allergens: {id: number, name: string}[], markedAllergens: number[]): boolean {
    return allergens.some(all => markedAllergens.includes(all.id));
  }
}
